export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SET_START_INFO_LOADED = 'SET_START_INFO_LOADED';
export const SET_DROPDOWN_OPENED = 'SET_DROPDOWN_OPENED';
